import { render, staticRenderFns } from "./read-table.vue?vue&type=template&id=39130c6e&scoped=true&"
import script from "./read-table.vue?vue&type=script&lang=ts&"
export * from "./read-table.vue?vue&type=script&lang=ts&"
import style0 from "./read-table.vue?vue&type=style&index=0&id=39130c6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39130c6e",
  null
  
)

export default component.exports